import { all, takeEvery, put, call } from 'redux-saga/effects'
import { getPaisesInfo, getPaisesInfoFiltered } from 'services/logisticaPedido'
import { actions } from './actions'
import { putMessage, messageType } from '../../utiles/mensaje'

export function* GET_PAISES_INFO() {
  try {
    const paisesData = yield call(getPaisesInfo)
    if (paisesData.ok) {
      yield put({
        type: actions.PAISES_INFO_LOAD_SUCCEEDED,
        payload: paisesData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar países info')
      put({
        type: actions.PAISES_INFO_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PAISES_INFO_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export function* GET_PAISES_INFO_FILTERED(payload) {
  try {
    const paisesData = yield call(getPaisesInfoFiltered(payload))
    if (paisesData.ok) {
      yield put({
        type: actions.PAISES_INFO_LOAD_SUCCEEDED,
        payload: paisesData.data,
      })
    } else {
      putMessage(messageType.ERROR, 'Error al cargar países info')
      put({
        type: actions.PAISES_INFO_LOAD_FILED,
      })
    }
  } catch (e) {
    yield all([
      put({
        type: actions.PAISES_INFO_LOAD_FILED,
        error: e.message,
      }),
    ])
  }
}

export default function* rootSaga() {
  yield all([
    takeEvery(actions.PAISES_INFO_LOAD_REQUESTED, GET_PAISES_INFO),
    takeEvery(actions.PAISES_INFO_FILTERED_REQUESTED, GET_PAISES_INFO_FILTERED),
  ])
}
